
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"29","height":"29","rx":"2.7","stroke":"#737882"}}),_c('path',{attrs:{"d":"M15 9.916l-.694-.713C12.677 7.53 9.69 8.107 8.613 10.212c-.506.99-.62 2.419.304 4.243.89 1.757 2.742 3.86 6.083 6.152 3.34-2.291 5.192-4.395 6.083-6.152.924-1.825.811-3.253.304-4.243-1.078-2.105-4.065-2.684-5.693-1.01L15 9.916zm0 11.857C.16 11.968 10.43 4.315 14.83 8.363c.057.053.115.109.17.166.054-.057.111-.112.17-.165 4.397-4.05 14.668 3.603-.17 13.41z","fill":"#737882"}})])
          )
        }
      }
    